import { render } from "./CandidateCartInternal.vue?vue&type=template&id=b388e902&scoped=true"
import script from "./CandidateCartInternal.vue?vue&type=script&lang=js"
export * from "./CandidateCartInternal.vue?vue&type=script&lang=js"

import "./CandidateCartInternal.vue?vue&type=style&index=0&id=b388e902&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b388e902"]])

export default __exports__